import { useMemo } from 'react'
import { useAppSelector } from 'app/state'
import { getLocalStorageItem } from 'app/api/localStorage'

type News = {
  title: JSX.Element
  content: JSX.Element
  description: JSX.Element
  action: JSX.Element
  enabled: boolean
  uniqueKey: string
}[]

export enum NEWS_LOCALSTORAGE_VALUES {
  SHOW_AFTER_LOGIN = 'showAfterLogin',
  DONT_SHOW = 'dontShow'
}

export function useNews() {
  const justLoggedIn = useAppSelector((state) => state.users.justLoggedIn)

  // Keeping as an example for future news.
  // This is the configuration for last CARTO Workflows announcement

  // const workflowsEnabled = useFeatureFlag(FeatureFlag.CartoWorkflows)
  // const navigate = useNavigate()

  // const news: News = useMemo(
  //   () => [
  //     {
  //       title: <FormattedMessage id="news.workflows.title" />,
  //       content: (
  //         <iframe
  //           src="https://player.vimeo.com/video/818386316?h=6ab9fa7c40&title=0&byline=0&portrait=0"
  //           width="100%"
  //           height="310"
  //           frameBorder="0"
  //           allow="autoplay; fullscreen; picture-in-picture"
  //           allowFullScreen
  //         ></iframe>
  //       ),
  //       description: (
  //         <FormattedMessage
  //           id="news.workflows.description"
  //           values={{
  //             strong: (content) => <strong>{content}</strong>,
  //             link: (content) => (
  //               <Link
  //                 target="_blank"
  //                 rel="noopener noreferrer"
  //                 href="https://docs.carto.com/carto-user-manual/workflows"
  //                 underline="none"
  //               >
  //                 {content}
  //               </Link>
  //             )
  //           }}
  //         />
  //       ),
  //       action: (
  //         <Button variant="outlined" onClick={() => navigate('/workflows')} color="primary">
  //           <FormattedMessage id="news.workflows.action" />
  //         </Button>
  //       ),
  //       enabled: workflowsEnabled,
  //       uniqueKey: 'CARTO_WORKFLOWS_NEW'
  //     }
  //   ],
  //   [navigate, workflowsEnabled]
  // )

  const news: News = useMemo(
    () => [
      /**
       * Empty news
       */
    ],
    []
  )

  const lastNew = useMemo(() => {
    const lastNew = [...news].reverse().find((n) => n.enabled)

    if (!lastNew) return undefined
    const localStorageValue = getLocalStorageItem(lastNew.uniqueKey)

    if (!localStorageValue) return lastNew
    if (localStorageValue === NEWS_LOCALSTORAGE_VALUES.DONT_SHOW) return undefined
    if (localStorageValue === NEWS_LOCALSTORAGE_VALUES.SHOW_AFTER_LOGIN && justLoggedIn) {
      return lastNew
    }
    return undefined
  }, [justLoggedIn, news])

  return { lastNew }
}
